import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgTemplateOutlet } from '@angular/common';
import { NavMenuItems } from '@core/layout/menu/navigation/nav-menu-items/nav-menu-items';

export const SHARED_MENU_IMPORTS = [
  MatMenuModule,
  MatButtonModule,
  MatIconModule,
  NgTemplateOutlet,
  NavMenuItems,
];